import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { EVENTS_OFFERINGS, BOOKING_URL } from "@/data/site";

export default function Events() {
  return (
    <div data-testid="events-page">
      <section className="pt-16 pb-20 md:pt-24 md:pb-28 border-b border-[#E5E5E5]">
        <div className="container-cc">
          <div className="overline mb-8"><span className="kicker-line" />Corporate Celebrations</div>
          <h1 className="font-serif-display text-5xl md:text-7xl leading-[1.02] max-w-5xl">
            Celebrations as <span className="italic text-[#A60201]">cultural moments</span> — not just events.
          </h1>
          <p className="mt-8 text-lg text-[#525252] max-w-2xl leading-relaxed">
            Annual days, foundation days, festive moments and recognition galas — designed with editorial taste and operational rigor. Every celebration is treated as a cultural intervention.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container-cc">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E5E5E5] border border-[#E5E5E5]">
            {EVENTS_OFFERINGS.map((e, i) => (
              <div key={i} data-testid={`event-${i}`} className="bg-white p-8 hover:bg-[#FFE8D9] transition-colors">
                <div className="overline text-[#A60201]">{String(i + 1).padStart(2, "0")}</div>
                <div className="font-serif-display text-2xl mt-3">{e.title}</div>
                <div className="text-sm text-[#525252] mt-3 leading-relaxed">{e.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section bg-white border-y border-[#E5E5E5]">
        <div className="container-cc grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <div className="aspect-[4/3] overflow-hidden">
              <img src="https://images.pexels.com/photos/8847211/pexels-photo-8847211.jpeg" alt="Leadership gathering" className="w-full h-full object-cover" />
            </div>
          </div>
          <div className="lg:col-span-6">
            <div className="overline mb-6"><span className="kicker-line" />Our difference</div>
            <h2 className="font-serif-display text-4xl md:text-5xl leading-tight">Designed by people who understand culture, not just logistics.</h2>
            <div className="mt-8 space-y-5 text-[#525252] leading-relaxed">
              <p>Most celebrations are designed for the eye. We design them for the memory. Every brief begins with a culture conversation — what should employees feel, remember and share.</p>
              <p>Our execution standards rival any leading agency. Our cultural sensitivity is what sets us apart.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container-cc">
          <div className="bg-[#0A0A0A] text-white p-10 md:p-16">
            <h2 className="font-serif-display text-4xl md:text-5xl leading-tight max-w-3xl">Planning an annual day or foundation moment?</h2>
            <p className="mt-6 text-white/70 text-lg max-w-xl">Let's craft a celebration your employees will talk about for years.</p>
            <div className="mt-8 flex flex-wrap gap-4">
              <a href={BOOKING_URL} target="_blank" rel="noreferrer" className="btn-primary" data-testid="events-book-call">Book Discovery Call <ArrowUpRight size={16} /></a>
              <Link to="/contact" className="bg-transparent text-white border border-white px-7 py-3 text-sm font-semibold hover:bg-white hover:text-[#0A0A0A] transition-colors" data-testid="events-contact">Share your brief</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
